export const PERIODICITY_MONTHLY = 1
export const PERIODICITY_QUARTERLY = 3
export const PERIODICITY_SEMIANNUAL = 6
export const PERIODICITY_ANNUAL = 12

export const PERIODICITY_MAP = {
  Mensuelle: PERIODICITY_MONTHLY,
  Trimestrielle: PERIODICITY_QUARTERLY,
  Semestrielle: PERIODICITY_SEMIANNUAL,
  Annuelle: PERIODICITY_ANNUAL,
}
